export default [
  {
    path: '/manifestes-echange',
    name: 'exchange-manifest-list',
    props: true,
    component: () => import('@/views/exchangeManifests/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: "Manifestes d'échange",
      breadcrumb: [
        {
          text: "Manifestes d'échange",
          to: { name: 'exchange-manifest-list' },
        },
        {
          text: 'Liste',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'supplier'],
    },
  },
  {
    path: '/manifestes-echange/create',
    name: 'exchange-manifest-create',
    props: true,
    component: () => import('@/views/exchangeManifests/Create.vue'),
    meta: {
      requireLogin: true,
      pageTitle: "Créer un manifeste d'échange",
      breadcrumb: [
        {
          text: "Manifestes d'échange",
          to: { name: 'exchange-manifest-list' },
        },
        {
          text: 'Créer',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
  {
    path: '/manifestes-echange/:id',
    name: 'exchange-manifest-detail',
    props: true,
    component: () => import('@/views/exchangeManifests/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: "Manifeste d'échange",
      breadcrumb: [
        {
          text: "Manifestes d'échange",
          to: { name: 'exchange-manifest-list' },
        },
        {
          text: 'Détail',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'supplier'],
    },
  },
]
